<template>
    <div>
        <main role="main">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center mt-5 text-muted">
                        <br/><br/><br/>
                        <i class="fas fa-lock fa-5x"></i>
                        <br/><br/><br/>
                        <small>{{$t('text.dashboard.contactEmailForHelp')}}: <a :href="'mailto:' + getHelpEmailAddress">{{getHelpEmailAddress}}</a>.</small>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';

    export default {
        name: 'Unauthorized',
        components: {},

        data() {
            return {};
        },

        beforeCreate: function () {
            const _this = this;
            document.body.className = 'dashboard';

            // ugly hack to redirect to Dashboard if keycloak redirect uri was Unauthorized page, but role has permissions to visit Dashboard
            if(!Vue.prototype.$globalFunctions.checkIfRouteIsBlockedInProductionEnv({name: 'Dashboard', query: {logout: 'false'}})) {
                _this.$router.push({name: 'Dashboard'});
            }
        },
        computed: {
            getHelpEmailAddress() {
                return config.links.helpEmail
            }
        },

        methods: {}


    };
</script>



// WEBPACK FOOTER //
// src/pages/Unauthorized.vue